import * as React from 'react';
import { Select, Form, Text } from 'react-form';
import { BaseFormProps } from '../../interfaces';
import { PVACharacteristicFilterSelect } from '../../components';
import { NotificationService, LanguageDataService, SurveyVersionDataService, SurveyReportTypeDataService, CharacteristicDataService, CharacteristicGroupDataService } from '../../services';
import { CharacteristicGroupText, CharacteristicGroupSubGroupText, Language, SurveyVersion, SurveyReportType, CharacteristicGroupCharacteristic, Characteristic, CharacteristicGroup, CharacteristicCompare, CharacteristicCompareText, CharacteristicGroupSubGroup, CharacteristicGroupSubGroupCharacteristic } from '../../models';
import { PonderaEditModal } from '../../components/inclinationmodals';
import { observer, inject } from 'mobx-react';
import { computed } from 'mobx';
import { UserStore, FilterStore } from '../../stores';
import { PVACharacteristicSelect } from '../';
import { NavLink } from 'react-router-dom';

interface CharacteristicGroupFormProps extends BaseFormProps {
    notificationService: NotificationService;
    surveyVersionId: number;
    UserStore?: UserStore;
    FilterStore?: FilterStore;
}

class CharacteristicGroupFormState {
    languages: Language[];
    surveyIsPublished: boolean;
    surveyReportTypes: SurveyReportType[];
    characteristics: Characteristic[];
    characteristicGroups: CharacteristicGroup[];
    selectedCharacteristicId: number | undefined;
}

@inject('UserStore', 'FilterStore') @observer
export class CharacteristicGroupForm extends React.Component<CharacteristicGroupFormProps, CharacteristicGroupFormState> {
    private surveyVersionDataService = new SurveyVersionDataService(this.props.notificationService);
    private languageDataService = new LanguageDataService(this.props.notificationService);
    private surveyReportTypeService = new SurveyReportTypeDataService(this.props.notificationService);
    private characteristicDataService = new CharacteristicDataService(this.props.notificationService);
    private characteristicGroupDataService = new CharacteristicGroupDataService(this.props.notificationService);
    
    @computed get isSuperAdmin() {
        return this.props.UserStore!.userRoleIn(['superAdmin']);
    }

    @computed get ReportTypeID() {
        if (this.props.FilterStore && this.props.FilterStore.surveyReportType) {
            return this.props.FilterStore.surveyReportType.id;
        }
        return 0;
    }

    constructor(props: CharacteristicGroupFormProps) {
        super(props);

        this.props.defaultValues.characteristicGroupTexts = this.props.defaultValues.characteristicGroupTexts || [];
        this.props.defaultValues.surveyVersionId = this.props.defaultValues.surveyVersionId || this.props.surveyVersionId;
        this.props.defaultValues.characteristicGroupCharacteristics = this.props.defaultValues.characteristicGroupCharacteristics || [];
        this.props.defaultValues.characteristicGroupSubGroups = this.props.defaultValues.characteristicGroupSubGroups || [];
        this.state = {
            languages: [],
            surveyIsPublished: false,
            surveyReportTypes: [],
            characteristics: [],
            selectedCharacteristicId: undefined,
            characteristicGroups: []
        };
    }

    public componentDidMount() {
        this.surveyVersionDataService.get(this.props.surveyVersionId).then((surveyVersion: SurveyVersion) => {
            this.setState({
                surveyIsPublished: surveyVersion.published !== null ? true : false
            });

            this.characteristicGroupDataService.getAllBySurveyVersion(surveyVersion).then((characteristicGroups: CharacteristicGroup[]) => {
                this.setState({
                    characteristicGroups: characteristicGroups
                });
            });

            this.characteristicDataService.getAllBySurveyVersion(surveyVersion).then((characteristics: Characteristic[]) => {
                if (characteristics && characteristics.length > 0) {
                    characteristics.sort((c1: Characteristic, c2: Characteristic) => {
                        if (c1.name > c2.name) {
                            return 1;
                        } else if (c1.name < c2.name) {
                            return -1;
                        }
                        return 0;
                    });
                    this.setState({
                        characteristics: characteristics,
                        selectedCharacteristicId: characteristics[0].id
                    });
                }
            });

            this.surveyReportTypeService.getBySurvey(surveyVersion.surveyID).then((surveyReportTypes: SurveyReportType[]) => {
                this.setState({
                    surveyReportTypes: surveyReportTypes
                });
            });
        });

        this.languageDataService.getAll().then((languages: Language[]) => {
            this.setState({
                languages: languages
            });
        });
    }

    public addSubGroup(formApi: any, e: any) {
        var result = new CharacteristicGroupSubGroup();
        result.characteristicGroupSubGroupCharacteristics = [];
        result.characteristicGroupSubGroupTexts = [];
        formApi.values.characteristicGroupSubGroups.push(result);
        this.forceUpdate();
    }

    public addCGSGC(formApi: any, cgsgInd: number, e: any) {
        if (this.state.selectedCharacteristicId) {
            var result = new CharacteristicGroupSubGroupCharacteristic();
            result.characteristicID = this.state.selectedCharacteristicId;
            result.characteristic = this.state.characteristics.find((c: Characteristic) => {
                return c.id === result.characteristicID;
            });
            formApi.values.characteristicGroupSubGroups[cgsgInd].characteristicGroupSubGroupCharacteristics.push(result);
            this.forceUpdate();
        }
    }

    public addCGC(formApi: any, e: any) {
        var result = new CharacteristicGroupCharacteristic();
        if (this.state.selectedCharacteristicId) {
            result.characteristicID = this.state.selectedCharacteristicId;
            result.characteristic = this.state.characteristics.find((c: Characteristic) => {
                return c.id === result.characteristicID;
            });
            formApi.values.characteristicGroupCharacteristics.push(result);
            this.forceUpdate();
        }
    }

    private submit(values: any) {
        this.props.submit(values);
    }

    public render() {

        const languageOpts: any = [];
        if (this.state.languages) {
            this.state.languages.map((x: Language) => {
                languageOpts.push({
                    label: x.name,
                    value: x.id
                });
            });
        }

        const surveyReportTypes: any = [];
        if (this.state.surveyReportTypes) {
            this.state.surveyReportTypes.map((x: SurveyReportType) => {
                surveyReportTypes.push({
                    label: x.name,
                    value: x.id
                });
            });
        }

        var characteristicGroups: CharacteristicGroup[] = [];
        const characteristicIDsGrouped: any = [];
        this.state.characteristicGroups.map((x) => {
            characteristicGroups.push(x);
            x.characteristicGroupCharacteristics.map((cgc: CharacteristicGroupCharacteristic) => {                
                characteristicIDsGrouped.push(cgc.characteristicID);
            });
        });

        var characteristicGroupUngrouped = new CharacteristicGroup();
        characteristicGroupUngrouped.id = -1;
        characteristicGroupUngrouped.name = 'Ungrouped';
        characteristicGroupUngrouped.sort = 999999999;
        characteristicGroupUngrouped.characteristics = [];
        characteristicGroupUngrouped.characteristicGroupCharacteristics = [];
        characteristicGroupUngrouped.surveyReportTypeID = this.ReportTypeID;
        this.state.characteristics.filter(c => {
            return characteristicIDsGrouped.indexOf(c.id) === -1;
        }).map((c) => {
            characteristicGroupUngrouped.characteristics.push(c);
        });
        characteristicGroups.push(characteristicGroupUngrouped);

        const characteristicGroupDisplayTypeOptions: any = [
            {
                label: 'Normal',
                value: 'normal'
            },
            {
                label: 'ResponseIndicator',
                value: 'responseIndicator'
            }   
        ];

        return (
            <Form
                defaultValues={this.props.defaultValues}
                onSubmit={submittedValues => this.submit(submittedValues)}
            >
                {formApi => (
                    <form onSubmit={formApi.submitForm} id="entityForm">
                        <fieldset>
                            <div className="form-group">
                                <label htmlFor="name">Characteristic Group Name *</label>
                                <Text className="form-control" field="name" id="name" disabled={!this.isSuperAdmin} />
                            </div>

                            <div className="form-group">
                                <label htmlFor="name">Characteristic Group Domain *</label>
                                <Text className="form-control" field="subtitle" id="subtitle" disabled={!this.isSuperAdmin} />
                            </div>

                            <div className="form-group">
                                <label htmlFor="name">Survey Report Type</label>
                                <Select className="form-control" field="surveyReportTypeID" id="surveyReportTypeId" options={surveyReportTypes} />
                            </div>

                            <fieldset>
                                <label htmlFor="name">Display Type</label>
                                <Select className="form-control" field="characteristicGroupDisplayType" id="characteristicGroupDisplayType" options={characteristicGroupDisplayTypeOptions} />
                            </fieldset>

                            <div className="form-group">
                                <label htmlFor="name">Sort</label>
                                <Text className="form-control" field="sort" id="sort" />
                            </div>
                        </fieldset>

                        <h3>Characteristics</h3>
                        <table className="table table-striped">
                            <thead>
                                <tr>
                                    <td>Characteristic</td>
                                    <td>Sort</td>
                                    <td />
                                </tr>
                            </thead>
                            <tbody>
                                {formApi.values.characteristicGroupCharacteristics.map((cgc: CharacteristicGroupCharacteristic, ind: number) => {
                                    return <tr key={`cgc-${ind}`}>
                                        <td>
                                            <NavLink to={`/characteristic/${cgc.characteristic ? cgc.characteristic.id : 0}`}>{cgc.characteristic && cgc.characteristic.name}</NavLink> 
                                        </td>
                                        <td>
                                            <input className="form-control" type="text" value={cgc.sort} onChange={(e) => { cgc.sort = parseInt(e.target.value, 10); this.forceUpdate(); }} />
                                        </td>
                                        <td>
                                            <a className="btn btn-danger" onClick={(e) => { formApi.values.characteristicGroupCharacteristics.splice(ind, 1); this.forceUpdate(); }}>Remove</a>
                                        </td>
                                    </tr>;
                                })}
                            </tbody>
                        </table>
                        <div className="row">
                            <div className="col-xs-8">
                                <PVACharacteristicFilterSelect notificationService={this.props.notificationService} surveyVersionId={this.props.surveyVersionId} selected={this.state.selectedCharacteristicId} onChange={(e: any) => this.setState({selectedCharacteristicId: parseInt(e.target.value, 10)})} />
                            </div>
                            <div className="col-xs-4">
                                <a className="btn btn-default btn-block" onClick={(e) => { this.addCGC(formApi, e); }}>Add</a>
                            </div>
                        </div>

                        <hr />

                        <h3>Sub Groups</h3>
                        {formApi.values.characteristicGroupSubGroups && formApi.values.characteristicGroupSubGroups.map((cgsg: CharacteristicGroupSubGroup, cgsgInd: number) => {
                            return <div key={`sub-group-${cgsgInd}`} className="char-group-sub-group">
                                <div className="row">
                                    <div className="col-xs-6">
                                        <Text className="form-control" placeholder="Name" field={['characteristicGroupSubGroups', cgsgInd, 'name']} id={`cgsg-${cgsgInd}`} />
                                    </div>
                                    <div className="col-xs-5">
                                        <Text className="form-control" placeholder="Sort" field={['characteristicGroupSubGroups', cgsgInd, 'sort']} id={`cgsg-sort-${cgsgInd}`} />
                                    </div>
                                    <div className="col-xs-1">
                                        <a className="btn btn-block btn-danger" id={`cgsg-sort-del-${cgsgInd}`} onClick={() => this.removeSubGroup(formApi, cgsgInd)}>X</a>
                                    </div>
                                </div>
                                <div style={{paddingLeft: '50px'}}>
                                    <h4>Descriptions</h4>
                                    
                                    {cgsg.characteristicGroupSubGroupTexts.map((ct: CharacteristicGroupSubGroupText, ind: number) => {
                                        const props = {
                                            show: ct.showModal === true,
                                            onHide: (data: string) => {
                                                ct.showModal = false;
                                                ct.value = data;
                                                this.forceUpdate();
                                            },
                                            title: 'Content',
                                            content: ct.value || ''
                                        };

                                        return <tr key={`char-text-${ind}`}>
                                            <td>
                                                <Select className="form-control" field={['characteristicGroupTexts', ind, 'languageId']} options={languageOpts} />
                                            </td>
                                            <td>
                                                <a className="btn btn-default" onClick={(e) => { ct.showModal = true; this.forceUpdate(); }}>View/Edit</a>
                                                <PonderaEditModal {...props} />
                                            </td>
                                        </tr>;
                                    })}
                                    <div>
                                        <a className="btn btn-default form-control" onClick={(e) => this.addContentDesc(formApi.values, cgsgInd)}>Add Content</a>
                                    </div>
                                </div>
                                <div style={{paddingLeft: '50px'}}>
                                    <h4>Characteristics</h4>
                                    <table className="table table-striped">
                                        <thead>
                                            <tr>
                                                <td>Characteristic</td>
                                                <td>Sort</td>
                                                <td />
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {cgsg.characteristicGroupSubGroupCharacteristics.map((cgc: CharacteristicGroupSubGroupCharacteristic, ind: number) => {
                                                return <tr key={`cgc-${ind}`}>
                                                    <td>
                                                        <NavLink to={`/characteristic/${cgc.characteristic ? cgc.characteristic.id : 0}`}>{cgc.characteristic && cgc.characteristic.name}</NavLink> 
                                                    </td>
                                                    <td>
                                                        <input className="form-control" type="text" value={cgc.sort} onChange={(e) => { cgc.sort = parseInt(e.target.value, 10); this.forceUpdate(); }} />
                                                    </td>
                                                    <td>
                                                        <a className="btn btn-danger" onClick={(e) => { formApi.values.characteristicGroupSubGroups[cgsgInd].characteristicGroupSubGroupCharacteristics.splice(ind, 1); this.forceUpdate(); }}>Remove</a>
                                                    </td>
                                                </tr>;
                                            })}
                                        </tbody>
                                    </table>
                                    <div className="row">
                                        <div className="col-xs-8">
                                            <PVACharacteristicFilterSelect notificationService={this.props.notificationService} surveyVersionId={this.props.surveyVersionId} selected={this.state.selectedCharacteristicId} onChange={(e: any) => this.setState({selectedCharacteristicId: parseInt(e.target.value, 10)})} />
                                        </div>
                                        <div className="col-xs-4">
                                            <a className="btn btn-default btn-block" onClick={(e) => { this.addCGSGC(formApi, cgsgInd, e); }}>Add</a>
                                        </div>
                                    </div>
                                </div>

                            </div>;
                        })}
                        <a className="btn btn-default btn-block" onClick={(e) => { this.addSubGroup(formApi, e); }}>Add Sub Group</a>

                        <hr />

                        <h3>About</h3>

                        {formApi.values.characteristicGroupTexts.map((ct: CharacteristicGroupText, ind: number) => {
                            if (ct.textType !== 'about') {
                                return;
                            }

                            const props = {
                                show: ct.showModal === true,
                                onHide: (data: string) => {
                                    ct.showModal = false;
                                    ct.value = data;
                                    this.forceUpdate();
                                },
                                title: 'Content',
                                content: ct.value || ''
                            };

                            return <tr key={`char-text-${ind}`}>
                                <td>
                                    <Select className="form-control" field={['characteristicGroupTexts', ind, 'languageId']} options={languageOpts} />
                                </td>
                                <td>
                                    <a className="btn btn-default" onClick={(e) => { ct.showModal = true; this.forceUpdate(); }}>View/Edit</a>
                                    <PonderaEditModal {...props} />
                                </td>
                            </tr>;
                        })}

                        <div className="form-group">
                            <div className="row">
                                <div className="col-xs-4">
                                    <a className="btn btn-default form-control" onClick={(e) => this.addContent(formApi.values, 'about')}>Add Content</a>
                                </div>
                            </div>
                        </div>

                        <hr />

                        <h3>PVA Compare</h3>
                        <i>Used on the Individual Report</i>
                        <div style={{display: 'flex', flexDirection: 'column'}}>
                            {
                                formApi.values.characteristicCompares.sort((cc1: CharacteristicCompare, cc2: CharacteristicCompare) => {
                                    if (cc1.sort > cc2.sort) {
                                        return 1;
                                    } else if (cc1.sort < cc2.sort) {
                                        return -1;
                                    }
                                    return 0;
                                }).map((cc: CharacteristicCompare, ind: number) => {
                                    var left = cc.characteristicCompareTexts.find((cct: CharacteristicCompareText) => {
                                        return cct.textType === 'left';
                                    });
                                    var right = cc.characteristicCompareTexts.find((cct: CharacteristicCompareText) => {
                                        return cct.textType === 'right';
                                    });
                                    return (
                                        <div className="pva-compare-edit-box" key={`cc-${cc.id || ('ind-' + ind)}`} style={{marginBottom: '15px'}}>
                                            <div style={{display: 'flex', flexDirection: 'row', marginBottom: '5px'}}>
                                                <div style={{flexGrow: 3}}>
                                                    <label>Name</label>
                                                    <input placeholder={'Name'} className="form-control" type="text" value={cc.name} onChange={(e) => { cc.name = e.target.value; this.forceUpdate(); }} />
                                                </div>
                                                <div style={{flexGrow: 1, padding: '0 5px'}}>
                                                    <label>Sort Order</label>
                                                    <input placeholder="Sort" type="number" className="form-control" value={cc.sort} onChange={(e) => { cc.sort = parseInt(e.target.value, 10); this.forceUpdate(); }} />
                                                </div>
                                                <div>
                                                    <a className="btn btn-danger" onClick={(e) => this.removePVACompare(formApi, ind)}>Remove</a>
                                                </div> 
                                            </div>
                                            <div style={{display: 'flex', flexDirection: 'row'}}>
                                                <div style={{paddingRight: '5px'}}>
                                                    {left && this.viewEditCCT(left)}
                                                </div>
                                                <div style={{flexGrow: 2, paddingRight: '5px'}}>
                                                    <PVACharacteristicSelect showAll={true} options={this.state.characteristics} groups={characteristicGroups} selected={cc.characteristicLeftID} onChange={(e: any) => { cc.characteristicLeftID = parseInt(e.target.value, 10); this.forceUpdate(); }} />
                                                </div>
                                                <div style={{flexGrow: 2, paddingRight: '5px'}}>
                                                    <PVACharacteristicSelect showAll={true} options={this.state.characteristics} groups={characteristicGroups} selected={cc.characteristicRightID} onChange={(e: any) => { cc.characteristicRightID = parseInt(e.target.value, 10); this.forceUpdate(); }} />
                                                </div>
                                                <div>
                                                    {right && this.viewEditCCT(right)}
                                                </div>
                                            </div>
                                            <br />
                                            <div style={{display: 'flex', flexDirection: 'row'}}>
                                                <div style={{paddingRight: '5px'}}>
                                                    <label>Scoring Type</label>
                                                    <select className="form-control" onChange={(e) => { cc.characteristicCompareScoreType = e.target.value; this.forceUpdate(); }} value={cc.characteristicCompareScoreType}>
                                                        <option value="normal">Normal</option>
                                                        <option value="thresholdGreater">Threshold Greater Than</option>
                                                        <option value="thresholdLessThan">Threshold Less Than</option>
                                                        <option value="forceGreater">Force Greater Than</option>
                                                        <option value="forceLessThan">Force Less Than</option>
                                                    </select>
                                                </div>
                                                {cc.characteristicCompareScoreType !== 'normal' &&
                                                <div style={{flexGrow: 3, paddingRight: '5px'}}>
                                                    <label>Target Side</label>
                                                    <select className="form-control" onChange={(e) => { cc.characteristicCompareScoreSide = e.target.value; this.forceUpdate(); }} value={cc.characteristicCompareScoreSide}>
                                                        <option value="left">Left{this.ccName(cc.characteristicLeftID)}</option>
                                                        <option value="right">Right{this.ccName(cc.characteristicRightID)}</option>
                                                    </select>
                                                </div>}
                                                {cc.characteristicCompareScoreType !== 'normal' &&
                                                <div style={{flexGrow: 2, paddingRight: '5px'}}>
                                                    <label>Threshold</label>
                                                    <input placeholder="Threshold" type="number" className="form-control" value={cc.threshold} onChange={(e) => { cc.threshold = parseFloat(e.target.value); this.forceUpdate(); }} />
                                                </div>}
                                            </div>
                                            <div style={{display: 'flex', flexDirection: 'row'}}>
                                                <label>Use on Interaction Report</label>
                                                <input type="checkbox" checked={cc.useInteractionReport} onChange={(e: any) => { cc.useInteractionReport = !cc.useInteractionReport; this.forceUpdate(); }} />
                                            </div>
                                            <div>
                                                <br />
                                                <span>{this.explain(cc)}</span>
                                            </div>
                                        </div>
                                    );
                                })
                            }
                        </div>
                        <a className="btn btn-default" onClick={(e) => { this.addCompare(formApi); }}>Add</a>

                        <hr />

                        <button type="submit" className="btn btn-primary">Save</button>
                        <div style={{paddingBottom: '200px'}} />
                    </form>
                )}
            </Form>
        );
    }

    private explain(cc: CharacteristicCompare) {
        if (cc.characteristicCompareScoreType === 'normal') {
            return '';
        }

        if (cc.characteristicCompareScoreType === 'thresholdGreater') {
            if (cc.characteristicCompareScoreSide === 'left') {
                return 'When \'' + this.ccNameSimple(cc.characteristicLeftID) + '\' is greater than ' + cc.threshold + ' it will always show. Otherwise it will show whichever score is greater.';
            } else {
                return 'When \'' + this.ccNameSimple(cc.characteristicRightID) + '\' is greater than ' + cc.threshold + ' it will always show. Otherwise it will show whichever score is greater.';
            }
        }

        if (cc.characteristicCompareScoreType === 'thresholdLessThan') {
            if (cc.characteristicCompareScoreSide === 'left') {
                return 'When \'' + this.ccNameSimple(cc.characteristicLeftID)  + '\' is less than \'' + cc.threshold + '\' it will always show. Otherwise it will show whichever score is greater.';
            } else {
                return 'When \'' + this.ccNameSimple(cc.characteristicRightID) + '\' is less than \'' + cc.threshold + '\' it will always show. Otherwise it will show whichever score is greater.';
            }
        }
        
        if (cc.characteristicCompareScoreType === 'forceGreater') {
            if (cc.characteristicCompareScoreSide === 'left') {
                return 'When \'' + this.ccNameSimple(cc.characteristicLeftID)  + '\' is greater than \'' + cc.threshold + '\' it will always show. Otherwise it will show \'' + this.ccNameSimple(cc.characteristicRightID) + '\'.';
            } else {
                return 'When \'' + this.ccNameSimple(cc.characteristicRightID) + '\' is greater than \'' + cc.threshold + '\' it will always show. Otherwise it will show \'' + this.ccNameSimple(cc.characteristicLeftID)  + '\'.';
            }
        }

        if (cc.characteristicCompareScoreType === 'forceLessThan') {
            if (cc.characteristicCompareScoreSide === 'left') {
                return 'When \'' + this.ccNameSimple(cc.characteristicLeftID)  + '\' is less than \'' + cc.threshold + '\' it will always show. Otherwise it will show \'' + this.ccNameSimple(cc.characteristicRightID) + '\'.';
            } else {
                return 'When \'' + this.ccNameSimple(cc.characteristicRightID) + '\' is less than \'' + cc.threshold + '\' it will always show. Otherwise it will show \'' + this.ccNameSimple(cc.characteristicLeftID)  + '\'.';
            }
        }

        return '';
    }

    private ccNameSimple(id: number) {
        var ch = this.state.characteristics.find((c: Characteristic) => {
            return c.id === id;
        });
        if (ch) {
            return ch.name;
        }
        return '';
    }

    private ccName(id: number) {
        var ch = this.state.characteristics.find((c: Characteristic) => {
            return c.id === id;
        });
        if (ch) {
            return ' (' + ch.name + ')'; 
        }
        return '';
    }

    private viewEditCCT(characteristicCompareText: CharacteristicCompareText) {

        const props = {
            show: characteristicCompareText.showModal === true,
            onHide: (data: string) => {
                characteristicCompareText.showModal = false;
                characteristicCompareText.value = data;
                this.forceUpdate();
            },
            title: 'Content',
            content: characteristicCompareText.value || ''
        };

        return (
            <div>
                <a style={{paddingTop: '9px', paddingBottom: '9px'}} className="btn btn-default" onClick={(e) => { characteristicCompareText.showModal = true; this.forceUpdate(); }}>View/Edit</a>
                <PonderaEditModal {...props} />
            </div>);
    }

    private removePVACompare(formApi: any, ind: number) {
        if (confirm('Are you sure want to remove this PVA Compare?')) {
            var comparisons = formApi.values.characteristicCompares;
            comparisons.splice(ind, 1);
            formApi.setValue('characteristicCompares', comparisons);
            this.forceUpdate();
        }
    }

    private nextSortOrder(formApi: any) {
        var largest: number = -1;
        formApi.values.characteristicCompares.map((cc: any) => {
            if (cc.sort > largest) {
                largest = cc.sort;
            }
        });

        return largest + 1;
    }

    addCompare(formApi: any) {
        var comparisons = formApi.values.characteristicCompares;
        
        var cc = new CharacteristicCompare();
        cc.sort = this.nextSortOrder(formApi);
        cc.characteristicLeft = new Characteristic();
        cc.characteristicRight = new Characteristic();
        cc.characteristicCompareTexts = [
            new CharacteristicCompareText(),
            new CharacteristicCompareText()
        ];
        cc.characteristicCompareTexts[0].textType = 'left';
        cc.characteristicCompareTexts[0].languageId = 1;
        cc.characteristicCompareTexts[1].textType = 'right';
        cc.characteristicCompareTexts[1].languageId = 1;

        cc.characteristicCompareScoreType = 'normal';

        if (this.state.surveyReportTypes && this.state.surveyReportTypes.length > 0) {
            cc.surveyReportTypeID = this.state.surveyReportTypes[0].id;
        }

        comparisons.push(cc);
        formApi.setValue('characteristicCompares', comparisons);
        this.forceUpdate();
    }
    
    private addContent(formValues: any, textType: string) {
        var ct = new CharacteristicGroupText();
        ct.textType = textType;
        ct.languageId = 1;
        formValues.characteristicGroupTexts.push(ct);
        this.forceUpdate();
    }

    private addContentDesc(formValues: any, cgsg: number) {
        var ct = new CharacteristicGroupSubGroupText();
        ct.languageId = 1;
        formValues.characteristicGroupSubGroups[cgsg].characteristicGroupSubGroupTexts.push(ct);
        this.forceUpdate();
    }

    private removeSubGroup(formApi: any, cgsgInd: number) {
        var characteristicGroupSubGroups = formApi.values.characteristicGroupSubGroups;
        characteristicGroupSubGroups.splice(cgsgInd, 1);
        formApi.setValue('characteristicGroupSubGroups', characteristicGroupSubGroups);
    }
}


// WEBPACK FOOTER //
// ./src/components/characteristicgroup/CharacteristicGroupForm.tsx